import { ObservabilityEvent, ErrorCategory } from '../constants';

export const AUTH_REGISTER_FAILURE = ObservabilityEvent.RegisterFailed;
export const AUTH_SIGNIN_FAILURE = ObservabilityEvent.SignInFailed;
export const AUTH_ERROR_INVALID_CREDENTIALS = ErrorCategory.InvalidCredentials;
export const AUTH_ERROR_VALIDATION = ErrorCategory.ValidationRejected;
export const AUTH_ERROR_API = ErrorCategory.ApiCallFailed;
export const AUTH_ERROR_UNKNOWN = ErrorCategory.UnknownError;
